import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Layout from "./../layouts/Index";
import BlockLoader from "./../contentloaders/BlockLoader";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  Button,
  Modal,
  Form,
  FormControl,
  Accordion,
  InputGroup,
} from "react-bootstrap";
import {
  getProducts,
  deleteProduct,
  getMoreProducts,
  searchProduct,
  searchedProducts,
} from "./../../store/actions/ProductActions";
// import truncate from 'truncate-txt';
import { titleCase } from "./../../utils/index";
import ProductCardItem from "../common/ProductCardItem";
import "./../products/show.css";
import { FaPlus, FaSearch } from "react-icons/fa";

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoDialog: false,

      product: {},

      loading: false,

      search: "",

      privilege: 0,
    };
  }

  componentDidMount = async () => {
    this.setState({
      loading: true,
      privilege: parseInt(localStorage.getItem("ltdn_priv")),
    });

    const res = await this.props.getProducts();

    if (res) {
      this.setState({ loading: false });
    }
  };

  togglePhotosDialog = (product = null) => {
    if (product !== null) {
      this.setState({ photoDialog: !this.state.photoDialog, product });
    } else {
      this.setState({ photoDialog: !this.state.photoDialog, product: {} });
    }
  };

  delete = async () => {
    try {
      const { product } = this.state;

      const result = await this.props.deleteProduct(product.id);

      if (result) {
        toast.success("Product Deleted !", {
          position: "bottom-center",
        });

        await this.props.getProducts();

        this.setState({ photoDialog: !this.state.photoDialog, product: {} });
      }
    } catch (error) {
      console.log(error);

      this.setState({ photoDialog: !this.state.photoDialog, product: {} });
    }
  };

  fetchMoreProducts = async () => {
    try {
      this.setState({ loading: true });

      const {
        products: { next_page },
      } = this.props;

      const result = await this.props.getMoreProducts(next_page);

      if (result) {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
    }
  };

  searchProduct = async () => {
    try {
      let obj = { name: this.state.search };

      this.setState({ loading: true });

      const result = await this.props.searchProduct(obj);

      if (result.length === 0) {
          this.setState({ loading: false });
          return toast.warning("Product Not Found!", {
            position: "bottom-center",
          });
        }
      const searchedProductsResults = await this.props.searchedProducts(result);
      if (searchedProductsResults.length > 0) {
        toast.success("Products Found!", {
          autoClose: 1500,
          position: "bottom-center",
        });
      } else {
        toast.warning("Product Not Found!", {
          position: "bottom-center",
        });
      }
    } catch (error) {
      if (error.response !== undefined && error.response.status === 404) {
        toast.warning("Product Not Found!", {
          position: "bottom-center",
        });
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  keyPress = async (e) => {
    try {
      if (e.keyCode === 13) {
        await this.searchProduct();
      }
    } catch (error) {
      // console.log(error);

      if (error.response !== undefined && error.response.status === 404) {
        toast.warning("Product Not Found!", {
          position: "bottom-center",
        });
      }
    }
  };

  handleChange = (e) => {
    this.setState({ search: e.target.value });
  };

  refresh = async () => {
    this.setState({ loading: true, product_name: ""});

    const result = await this.props.getProducts();

    if (result) {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      products,
      history,
      products: { page, pages },
    } = this.props;

    const { photoDialog, product, loading} = this.state;

    return (
      <Layout>
        <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
          <Container>
            <Row>
              <Col xs="12" md="6" lg="4" className="mb-3 mx-auto">
                <Form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    if (!this.state.search || !this.state.search.trim()) return; // avoid undefined
                    await this.searchProduct();
                  }}
                >
                  <InputGroup className="search-input-group">
                    <FormControl
                      type="text"
                      name="product_name"
                      id="product_name"
                      placeholder="Search Product"
                      value={this.state.search || ""} // safe fallback
                      onChange={this.handleChange}
                      ref={(input) => (this.searchInput = input)}
                      className="rounded-pill shadow-sm"
                    />
                    {this.state.search && (
                      <Button
                        variant="outline-secondary"
                        onClick={() => {
                          this.setState({ search: "" }, () => {
                            this.refresh();
                          });
                        }}
                        className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                        style={{
                          width: "40px",
                          height: "40px",
                          padding: 0,
                        }}
                      >
                        ×
                      </Button>
                    )}
                    <Button
                      variant="success"
                      type="submit"
                      disabled={!this.state.search || !this.state.search.trim()}
                      className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                      style={{
                        width: "40px",
                        height: "40px",
                        padding: 0,
                      }}
                    >
                      <FaSearch size={16} />
                    </Button>
                  </InputGroup>
                </Form>
              </Col>

              <Col sm="12" className="mb-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <h3 className="mb-0">Products</h3>

                  {loading ? (
                    <div style={{ width: "40px", height: "32px" }}>
                      <BlockLoader
                        width="40px"
                        height="32"
                        innerHeight="100%"
                        innerWidth="100%"
                        style={{
                          borderRadius: "4px",
                          backgroundColor: "#e0e0e0",
                        }}
                      />
                    </div>
                  ) : (
                    <Button
                      variant="success"
                      size="sm"
                      className="d-flex align-items-center justify-content-center"
                      style={{ width: "32px", height: "32px", padding: "0" }}
                      onClick={() => history.push("/admin/products/create")}
                    >
                      <FaPlus size={14} />
                    </Button>
                  )}
                </div>
              </Col>

              <Col sm="12">
                {!loading && (
                  <Accordion defaultActiveKey="0">
                    {products.data.map((p, i) => (
                      <ProductCardItem
                        key={i}
                        product={p}
                      />
                    ))}
                  </Accordion>
                )}
              </Col>
              <Col sm="12">
                {loading && (
                  <BlockLoader
                    width="100%"
                    height="400px"
                    innerWidth="100%"
                    innerHeight="100%"
                  />
                )}
              </Col>

              {page < pages && (
                <Col
                  sm="12"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "2em",
                  }}
                >
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={() => this.fetchMoreProducts()}
                    disabled={loading}
                  >
                    {loading === true ? "Loading ..." : "Load More"}
                  </Button>
                </Col>
              )}
            </Row>
          </Container>
        </Col>

        <Modal show={photoDialog} onHide={this.togglePhotosDialog}>
          <Modal.Header closeButton>
            <Modal.Title>
              {product.name !== undefined && titleCase(product.name)}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <h6>Are you sure you want to delete {product.name} ?</h6>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.togglePhotosDialog}>
              Close
            </Button>

            <Button
              variant="danger"
              onClick={() => {
                this.delete();
              }}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    products: state.products,
  };
};

export default connect(mapStateToProps, {
  getProducts,
  deleteProduct,
  getMoreProducts,
  searchProduct,
  searchedProducts,
})(withRouter(Index));
